<script>
export default {
  props: ['author', 'staging'],

  computed: {
    roles() {
      let result = {}
      this.staging.forEach((staging) => {
        result[staging.title] = []
        if (staging.name) {
          const arrayPersons = staging.name.split(',')
          arrayPersons.forEach((person) => {
            result[staging.title].push({
              name: person,
              to: null
            })
          })
        } else {
          staging.value.forEach((person) => {
            if (person?.name)
              result[staging.title].push({
                name: person?.name,
                to: `/theater/staff/${person._id}`
              })
          })
        }
      })
      return result
    }
  },
  mounted() {
    console.log(this.author, this.staging)
  }
}
</script>

<template>
  <div class="grid grid-row-1 sm:grid-cols-2 gap-y-3 gap-x-6">
    <div class="flex flex-col" v-if="author">
      <div>
        <p class="font-sans font-regular text-gray-light text-base">Автор:</p>
      </div>
      <div>
        <p class="font-sans font-regular text-lg2">
          <b class="text-base font-medium">{{ author }}</b>
        </p>
      </div>
    </div>

    <template v-for="(role, key) in roles">
      <div v-if="role.length" :key="key" class="flex flex-col space-y-0.5">
        <p class="font-sans font-regular text-gray-light text-base">
          {{ key }}
        </p>
        <div class="">
          <template v-for="person in role">
            <p v-if="person?.name" :key="person?.name">
              <template v-if="person.to">
                <router-link :to="person.to">
                  <b class="text-base font-medium">{{ person?.name }}</b>
                </router-link>
              </template>
              <template v-else>
                <b class="text-base font-medium">{{ person?.name }}</b>
              </template>
            </p>
          </template>
        </div>
      </div>
    </template>
  </div>
</template>
